import axios from 'axios';
import { ref } from 'vue';

export function useFetchModels<T>(
  url: string,
  mutationFunc?: (_data: Record<string, string>) => T[],
) {
  const data = ref<T[]>([]);
  const loading = ref(false);
  const fetched = ref(false);
  const error = ref<boolean | string | Error>(false);

  async function fetch(force: boolean = false): Promise<void> {
    if (fetched.value && !force)
      return;
    try {
      loading.value = true;
      const result = await axios.get(url);
      data.value = mutationFunc
        ? mutationFunc(result.data.data)
        : result.data.data;
      fetched.value = true;
    }
    catch (e: unknown) {
      error.value = e as Error;
      console.error(e);
    }
    finally {
      loading.value = false;
    }
  }

  return {
    data,
    loading,
    fetched,
    error,
    fetch,
  };
}
